export default __webpack_public_path__ + "static/media/labcode_logo_ico.8b96f854.svg";